/* DI LORENZO LAB | Product images: native Dawn gallery + reliable controls.
   Syncs with touch swipes, thumbnail selection and variant media updates.
*/
(function(){
  'use strict';
  const enhanced=new WeakSet();
  const mediaQuery=window.matchMedia('(max-width:749px)');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');

  function attach(root){
    if(enhanced.has(root))return;
    const gallery=root.closest('media-gallery');
    if(!gallery||typeof gallery.setActiveMedia!=='function')return;
    const viewport=gallery.querySelector('[id^="GalleryViewer-"]');
    const slider=gallery.querySelector('[id^="Slider-Gallery-"]');
    if(!viewport||!slider)return;
    const prev=root.querySelector('[data-dlb-gallery-prev]');
    const next=root.querySelector('[data-dlb-gallery-next]');
    const counter=root.querySelector('[data-dlb-gallery-counter]');
    if(!prev||!next)return;
    enhanced.add(root);
    let raf=0,announceTimer;
    const slides=()=>Array.from(slider.children).filter(el=>el.matches('li.product__media-item[data-media-id]'));

    function visualIndex(items){
      if(!items.length)return 0;
      if(!mediaQuery.matches){
        const active=items.findIndex(el=>el.classList.contains('is-active'));
        return active<0?0:active;
      }
      let best=0,min=Infinity;
      const railStart=slider.getBoundingClientRect().left;
      items.forEach(function(el,i){
        if(el.getClientRects().length===0)return;
        const diff=Math.abs(el.getBoundingClientRect().left-railStart);
        if(diff<min){min=diff;best=i}
      });
      return best;
    }
    function sync(announce){
      const items=slides();
      root.hidden=items.length<2;
      if(items.length<2)return;
      const idx=visualIndex(items);
      if(counter)counter.textContent=(idx+1)+' / '+items.length;
      prev.setAttribute('aria-label','Fotografia precedente');
      next.setAttribute('aria-label','Fotografia successiva');
      if(announce&&counter)counter.setAttribute('aria-live','polite');
    }
    function queue(announce){
      if(!raf)raf=requestAnimationFrame(function(){raf=0;sync(false)});
      if(announce){
        clearTimeout(announceTimer);
        announceTimer=setTimeout(function(){sync(true)},170);
      }
    }
    function step(offset){
      const items=slides();
      if(items.length<2)return;
      const from=visualIndex(items);
      const idx=(from+offset+items.length)%items.length;
      const target=items[idx];
      const id=target.dataset.mediaId;
      if(!id)return;
      gallery.setActiveMedia(id,false);
      if(mediaQuery.matches){
        // Dawn's variant/thumbnail state stays authoritative. Native swipe
        // works on the same <ul>; this call only navigates to the clicked slide.
        requestAnimationFrame(function(){
          if(!target.isConnected)return;
          const left=target.getBoundingClientRect().left-slider.getBoundingClientRect().left+slider.scrollLeft;
          slider.scrollTo({left:left,behavior:reduced.matches?'auto':'smooth'});
        });
      }
      queue(true);
    }
    prev.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();step(-1)});
    next.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();step(1)});
    slider.addEventListener('scroll',function(){queue(true)},{passive:true});
    viewport.addEventListener('slideChanged',function(){queue(true)});
    const observer=new MutationObserver(function(){queue(true)});
    observer.observe(slider,{childList:true,subtree:false});
    const watch=()=>slides().forEach(el=>observer.observe(el,{attributes:true,attributeFilter:['class']}));
    watch();
    gallery.addEventListener('change',function(){queue(true)});
    window.addEventListener('resize',function(){queue(false)},{passive:true});
    queue(false);
  }
  function init(){document.querySelectorAll('[data-dlb-gallery-controls]').forEach(attach)}
  function start(){
    if(window.customElements&&!customElements.get('media-gallery')){
      customElements.whenDefined('media-gallery').then(init);
    }else{init()}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',start);
})();
